import React, { useMemo } from "react";
import "./TaskDetails.css";
import { Pivot, PivotItem, DefaultButton } from "@fluentui/react";
import axios from "axios";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import SpinningLoader from "components/Loaders/SpinningLoader";
import AllocatedTasks from "components/AllocatedTasks";
import TimeSheet from "components/TimeSheet";
import { useCallback } from "react";

const TaskList = ({ data, selectedTaskIndex, handleTaskSwitching }) => {
  if (Array.isArray(data) && data?.length !== 0) {
    return data?.map((item, index) => {
      return (
        <div key={`task${index}`}>
          <input
            type="radio"
            id="css"
            name="selectedTask"
            value={index}
            defaultChecked={selectedTaskIndex === index ? true : false}
            onClick={() => handleTaskSwitching(index)}
          />

          <label htmlFor="html" className="ms-fontSize-14">
            &nbsp; {item?.TaskName}
          </label>
          <br />
        </div>
      );
    });
  }
  return <>Task not available!</>;
};

const fetchAssignedTask = async () => {
  const userEmail = localStorage.getItem("userEmail");

  const response = await axios.get(
    `https://ik66dbp4jb.execute-api.us-east-2.amazonaws.com/Prod/username/${userEmail}`
  );

  return response.data;
};

const TaskDetails = () => {
  const [selectedTaskIndex, setSelectedTaskIndex] = React.useState(0);
  const navigate = useNavigate();

  const { data, isLoading, error } = useQuery(
    "fetchAssignedTasks",
    fetchAssignedTask,
    {
      cacheTime: 0,
    }
  );

  const isTaskData = useMemo(() => {
    return !!data?.length;
  }, [data]);

  const handleLogout = useCallback(() => {
    localStorage.clear();
    navigate("/login");
  }, [navigate]);

  const handleTaskSwitching = useCallback((dataIndex) => {
    setSelectedTaskIndex(dataIndex);
  }, []);

  if (isLoading) {
    return <SpinningLoader isLoading={isLoading} />;
  }
  if (error) {
    return (
      <center>
        <span className="ms-fontSize-20">Error: {error.message}</span>
      </center>
    );
  }

  return (
    <>
      <div className="main3">
        <div className="wrapper">
          <div className="sectionPart">
            <TaskList
              data={data}
              selectedTaskIndex={selectedTaskIndex}
              handleTaskSwitching={handleTaskSwitching}
            />
          </div>
          {isTaskData && (
            <div className="tab-container">
              <Pivot
                aria-label="tab Pivot Example"
                linkSize="large"
                linkFormat="tabs"
              >
                <PivotItem
                  headerText="Allocated Tasks"
                  itemKey="allocatedTask"
                  key="allocatedTask"
                >
                  {
                    <AllocatedTasks
                      data={data}
                      selectedTaskIndex={selectedTaskIndex}
                    />
                  }
                </PivotItem>
                <PivotItem
                  headerText="Time Sheet"
                  itemKey="timeSheet"
                  key="timeSheet"
                >
                  <TimeSheet
                    data={data}
                    selectedTaskIndex={selectedTaskIndex}
                  />
                </PivotItem>
              </Pivot>
            </div>
          )}
        </div>
        <DefaultButton className="LogoutBtn" onClick={handleLogout}>
          Logout
        </DefaultButton>
      </div>
    </>
  );
};

export default TaskDetails;
